// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { WebServices } from '../../shared/services/webServices';
//import { FormDataService2 } from '../../shared/services/formData2';
import { Helpers } from '../../shared/services/helpers';
import { FormAction } from '../../shared/classes/formAction';

//Only need this if you are going to be formatting into date strcutures, often used by calendars
//import { casNgbDateParserFormatter } from '../../shared/services/cas-NgbDateParserFormatter';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';

//Third Party
//import moment from 'moment';
//import { NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';


//Config/Globals
import { Enums } from '../../shared/enums.js';
    
//Auth & Config
import { authToken } from '../../shared/authToken';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
@Component({
    template : '<div class="ast-main-div" data-test-id="content_asset_type_management_list">\n\n    <!--Title-->\n    <h2 tabindex="-1" class="ast-title-div">{{_title}}</h2>\n\n    <div *ngIf="_isNationalPracticeDataSteward" style="margin:0 10px 15px 20px; font-style:italic">Provides National Data Steward with ability to Add and Edit Asset Types.</div>\n    <div *ngIf="!_isNationalPracticeDataSteward" style="margin:0 10px 15px 20px; font-style:italic">Provides National Data Steward with ability to View Asset Types.</div>\n\n    <div style="height:10px;"></div>\n\n    <!--Content Loading -->\n    <ng-template #loading>\n        <div class="ast-ui-content-loading">\n            <img src="public/cpd-images/loading.gif" />\n            <div style="margin-left:10px;">Loading...</div>\n        </div>\n    </ng-template>\n   \n    <!--Selected Practice Display-->\n    <!--<div *ngIf="!_isLoading()" class="ast-ui-cell">\n        <div class="ast-ui-group-lbl" role="heading" aria-label="Practice"><h3>Practice</h3></div>\n        <div style="margin:10px 0 5px 10px;">\n            <span style="font-weight:bold;margin-right:5px;">Practice Code:</span><span>{{_selectedPractice?.practice_code}}</span>\n            <span style="font-weight:bold;margin:0 5px 0 20px;">Practice Name:</span><span>{{_selectedPractice?.practice_name}}</span>\n        </div>\n    </div>-->\n\n\n    <!--Content Div -->\n    <div *ngIf="!_isLoading(); else loading" class="ast-ui-row" style="flex-grow:1;">\n\n        <!-- Narratives Grid --------------------------------->\n        <cas-grid #assetTypeGrid\n                  summary="{{_title}} List"\n                  [settings]="assetTypeGridSettings"\n                  (onRefreshClicked)="onGridRefreshClicked()"\n                  (onRowSelectionChanged)="onRowSelectionChanged()"\n                  (onPageChanged)="onPageChanged($event)"\n                  (onSearch)="onGridSearch($event)">\n        </cas-grid>\n\n\n\n    </div>\n\n</div>\n\n\n\n\n\n\n\n',
    styles : ['.ast-main-div{display:flex;flex-direction:column;position:absolute;top:0px;right:0px;bottom:0px;left:0px}.ast-ui-row{position:relative;margin:15px 0 0 0;border-top:solid 1px #ccc}.ast-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:10px 15px 10px 15px;margin:0 10px}.ast-ui-group-lbl{position:absolute;top:-8px;left:5px;background-color:#d4e2f2;border-radius:4px;border:solid 1px #b8b8b8;padding:1px 8px;box-shadow:1px 1px 5px rgba(0,0,0,0.3)}.ast-ui-content-loading{display:flex;font-style:italic;margin:10px 20px}.ast-title-div{margin:10px 8px 15px 8px;padding-bottom:4px;border-bottom:solid 1px #b8b8b8}'],
    providers:[ ]
})
export class AssetTypeManagementComponent {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('assetTypeGrid') assetTypeGrid;
    
    //Class wide member reference for the growls control
    growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    // Boiler Plater
    _allFieldsDisabled = false;
    _componentName = 'assetTypeManagement.js';
    _disposalFunctions = [];
    _formName = "asset_type_list";
    _loading = true;
    _sessionStorageObject = null;
    _title = "National - Asset Type Management";
    _isNationalPracticeDataSteward = false;
    //_now = moment();

    _selectedAssetType = null;
    
    //Grid settings
    assetTypeGridSettings = {
        hideClearSelectedButton:true,
        hideSearchBox:false,
        rowIdentifyForJAWS:true,
        rowIdentityFieldForJAWS:"practice_type_code",
        rowIdentityPrefixForJAWS:"Asset Type Code",
        showCheckboxColumn:true,
        positionAbsolute:true,

        columns : [
            { fieldName: 'practice_type_code', display:'Code', width:'10%', minWidth:50 },
            { fieldName: 'practice_type_code_name', display: 'Asset', width:'30%', minWidth:50 },
            { fieldName: 'publish', display: 'Published', width: '10%', minWidth: 75 },
            { fieldName: 'start_date', display: 'Start Date', width: '25%', minWidth: 75, procDataFn: this._formatDate.bind(this), dataType: 'date'}, //{ fieldName:'start_date', display: 'Start Date', width: '5%', minWidth: 75, procDataFn: (start_date, row) => { return this._procStartDateField(start_date, row); } },
            { fieldName: 'end_date', display: 'End Date', width: '25%', minWidth: 75, procDataFn: this._formatDate.bind(this), dataType: 'date' }
        ],
        rows : []
    }

    //An event listener handler method that will have "this" prebound so removeListener will work (which can't handle
    //removing a listener if it was bound in the registration)
    //_boundKeypressHandler = null;


    // INITIALIZATION/LIFECYCLE
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService, 
        cpdFormatters: CPDFormatters,
        //formDataService: FormDataService2,
        helpers: Helpers,
        route:ActivatedRoute,
        router:Router,
        webServices: WebServices){

        this.constructor.mapParams( this, arguments );

        // Growl Prep
        //--------------------
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({ 
	        appendToElementId:"cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        }); 

        //Init page
        this._markPageAsLoading(true);

        //Init local storage
        this._sessionStorageObject = this._loadSessionStorageObject();
        if (!this._sessionStorageObject) {

            this._sessionStorageObject = {
                currentPage:1,
                selectedAssetTypeCode: null
            }
            this._saveSessionStorageObject(this._sessionStorageObject);
        }
        
        //Handle nav menu events
        this._disposalFunctions.push( casNavBoxService.OnActionClicked$.subscribe( action => {
            this.NavBoxActionClicked(action);
        }));

        // Debugging
        //-------------------------------------------
        //casNavBoxService.ClearDebugEntries();
        //casNavBoxService.DebugEntries.push("Dump Local Storage");
        //let disposer = casNavBoxService.OnDebugEntryClicked$.subscribe( entry => {
        //    this._debugEntryClicked(entry);
        //});
        //this._disposalFunctions.push(disposer);

        //Keypress Handler
        //-------------------------------------------
        //Prebind the listener (not using this here, keep for later)
        //this._boundKeypressHandler = this._handleGlobalKeypress.bind(this);

        //Register the handler globally to keyup
        //window.addEventListener("keyup", this._boundKeypressHandler);
    }

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy(){
        this._disposalFunctions.map( x => x.unsubscribe() );
        //window.removeEventListener("keyup", this._boundKeypressHandler);
    }
    
    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {
        this.set508();
        this.setNavBoxActions();
        this.performAsyncOperations(() => {
            this.ngOnInit_Complete();
        });
    };

    //==================================
    // ngOnInit_Complete
    //==================================
    ngOnInit_Complete() {
        this._markPageAsLoading(false);
        this._isNationalPracticeDataSteward = authToken.user.role == Enums.Roles.NHQNationalPracticeDataSteward.id;
    }

    // FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";

            let el = document.getElementsByClassName("ast-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //==================================
    // performAsyncOperations
    //==================================
    performAsyncOperations(fnComplete) {
        this._loadGrid();
        if (fnComplete) { fnComplete(); }
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        let actions = [];

        switch (authToken.user.role) {
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_add_asset_type", "Add Asset Type"));
                actions.push(new FormAction("act_edit_asset_type", "Edit Asset Type"));
                break;

            default:
                break;
        }

        console.log(`[${this._componentName}:ngOnInit()] - actionLinks:`, actions);

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;
    }

    //==================================
    // onGridSearch
    //==================================
    onGridSearch(searchText) {

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0){
            this.assetTypeGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return (row.practice_type_code.toLowerCase().indexOf(searchText) >= 0 || row.practice_type_code_name.toLowerCase().indexOf(searchText) >= 0);
        };

        //Set the "search" filter on the grid
        this.assetTypeGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    // UI HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // NavBoxActionClicked
    //==================================
    NavBoxActionClicked(action){

        switch (action.field_name) {

            case "act_add_asset_type":
                this.router.navigate(["/cpdes/practices/assetTypes/add"]);
                break;

            case "act_edit_asset_type":
                if (this._selectedAssetType == null) {
                    this.growlBox.addGrowl("info", "You must select an asset type.");
                    break;
                }
                this.router.navigate(["/cpdes/practices/assetTypes/edit/" + this._selectedAssetType.practice_type_code]);
                break;
        }
    }

    //==================================
    // onGridRefreshClicked
    //==================================
    onGridRefreshClicked() {
        this._loadGrid(true);
        //Fresh load, go to first page
        this.assetTypeGrid.GoToFirstPage();
    };

    //==================================
    // onPageChanged
    //==================================
    // $event will contain the new page
    onPageChanged($event) {

        var newPage = $event;
    
        //Store the new page in the local storage
        this._sessionStorageObject.currentPage = newPage;
        this._saveSessionStorageObject(this._sessionStorageObject);
    }

    //==================================
    // onRowSelectionChanged
    //==================================
    onRowSelectionChanged(){

        if (this.assetTypeGrid) {
            this._selectedAssetType = this.assetTypeGrid.GetFirstSelectedRow();

            if (this._selectedAssetType) {
                this._sessionStorageObject.selectedAssetTypeCode = this._selectedAssetType.practice_type_code;
                this._saveSessionStorageObject(this._sessionStorageObject);

            }
            else {
                this._sessionStorageObject.selectedAssetTypeCode = null;
                this._saveSessionStorageObject(this._sessionStorageObject);
            }
        }
    }


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _loadGrid
    //==================================
    // Loads the grid using the current filter
    //  Returns:Promise(recordCount)
    _loadGrid(manageLoadIndicators, fnOnSuccess, fnOnError) {

        if (manageLoadIndicators) {
            this._markGridAsLoading(true);
            this.casNavBoxService.ActionsLoading = true;
        }

        this.webServices.Get({
            apiPath: "/practices/getPracticeTypeCodes",
            args: {
                fy: null,
                includeAll: true
            }
        })
            .then(res => {
                console.log("[{0}:/practices/getPracticeTypeCodes] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                //Errors in the callback trigger the catch for this service call (?!) and populate the alerts with errors the user shouldn't see.  Catch it here instead.
                try {

                    //Apply new data to the grid
                    this._setGridRows(dto);

                    //Hide the loading message
                    if (manageLoadIndicators) {
                        this._markGridAsLoading(false);
                        this.casNavBoxService.ActionsLoading = false;
                    }
                    if (fnOnSuccess) { fnOnSuccess(dto); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log("[ERROR][{0}:_loadGrid()]".format(this._componentName), err);

                    //Always hide the loading message on errors
                    this._markGridAsLoading(false);
                    this.casNavBoxService.ActionsLoading = false;

                    if (fnOnError) { fnOnError(); }
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));

                //Always hide the loading message on errors
                this._markGridAsLoading(false);
                this.casNavBoxService.ActionsLoading = false;

                if (fnOnError) { fnOnError(); }
            });
    };

    //==================================
    // _disableUI
    //==================================
    _disableUI(){
        this.casNavBoxService.DisableAllLinks();
        this._allFieldsDisabled = true;
    };

    //==================================
    // _enableUI
    //==================================
    _enableUI(){
        this.casNavBoxService.EnableAllLinks();
        this._allFieldsDisabled = false;
    };

    //==================================
    // _formatDate
    //==================================
    _formatDate(dateString){
        return this.cpdFormatters.formatDateString(dateString);
    };

    //==================================
    // _isLoading
    //==================================
    _isLoading() {
        return this._loading || this.casNavBoxService.ActionsLoading;
    }

    //==================================
    // _loadSessionStorageObject
    //==================================
    _loadSessionStorageObject() {
        var obj = sessionStorage.getItem(this._formName);
        return obj ? JSON.parse(obj) : null;
    }

    //==================================
    // _markGridAsLoading
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _markGridAsLoading(isLoading) {

        if (this.assetTypeGrid){
            this.assetTypeGrid.MarkAsLoading(isLoading);
        }
        else{
            this.assetTypeGridSettings.loading = isLoading;
        }
    }

    //==================================
    // _markPageAsLoading
    //==================================
    _markPageAsLoading(isLoading) {
        this._loading = isLoading;
    }

    //==================================
    // _saveSessionStorageObject
    //==================================
    _saveSessionStorageObject(obj) {
        if (!obj) { throw "[{0}:_saveSessionStorageObject] - obj must not be empty".format(this._componentName) }
        sessionStorage.setItem(this._formName, JSON.stringify(obj));
    }

    //==================================
    // _setGridRows
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _setGridRows(data) {

        if (this.assetTypeGrid){
            this.assetTypeGrid.SetRows(data);
        }
        else{
            this.assetTypeGridSettings.rows = data;
        }
    }

    //==================================
    // _sortGrid
    //==================================
    _sortGrid(column, direction) {

        // Let's give the grid a chance to render for a bit and then sort
        // once it comes up.  Keep it tight though, or we'll sort too long
        // after the grid comes up.
        this.helpers.executeOnCondition(
            () => { return !!this.assetTypeGrid; },
            () => { this.assetTypeGrid.SortGrid(column, direction); },
            50, 10
        );

    }


    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _debugEntryClicked
    //==================================
    _debugEntryClicked(entry){
        console.log("[narratives:_debugEntryClicked]");
        console.log("    ", entry);

        switch (entry){ 
            case "Dump Local Storage":
                console.log(this._sessionStorageObject);
        }
    };

}

